import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import useFetchWithMsal from '../hooks/useFetchWithMsal';
import { protectedResources, scopes } from "../authConfig";
import ProfileImg from '../img/default_profile.jpg';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';

function ProfilePhotoUpdateModal({ show, handleClose, activeAccount }) {
    const { execute } = useFetchWithMsal({
        scopes: scopes.callapi
    });    const [image, setImage] = useState(null);
    const [viewImage, setViewImage] = useState(null);
    const [cropData] = useState(null);
    const [cropper, setCropper] = useState(null);
    const cropperRef = useRef(null);

    const userId = activeAccount.localAccountId;

    useEffect(() => {
        const fetchUserPhoto = async () => {
            console.log("call fetchUserPhoto");
            try {
                const response = await execute("GET", protectedResources.getUserPhoto.endpoint + "?userId=" + userId, "", true);
                console.log("check point");
                if (!response || !response.ok) {
                    console.log("HTTP Status:" + response.status);
                    throw new Error("Failed to fetch user photo");
                }
                const blob = await response.blob();
                const imageUrl = URL.createObjectURL(blob);
                setViewImage(imageUrl); // 配列ではなく、imageUrlのみをセット
            } catch (error) {
                console.log("Exception error:" + error);
                setViewImage(ProfileImg);
            }
        };
        fetchUserPhoto();
    }, [execute, userId]);

    const handleFileChange = (event) => {
        // 拡張子が.jpgの場合のみ許可
        if (!event.target.files[0].name.match(/\.jpg$/)) {
            alert('jpgファイルを選択してください');
            return;
        }
        setImage(event.target.files[0]);
        setViewImage(URL.createObjectURL(event.target.files[0]));
    };

    const getCroppedCanvas = useCallback(async () => {
        if (!cropper) {
            return null;
        }

        const canvas = cropper.getCroppedCanvas();
        return new Promise((resolve) => {
            canvas.toBlob((blob) => {
                blob.name = 'newFile.jpeg';
                resolve(blob);
            }, 'image/jpeg');
        });
    }, [cropper]);

    const handleSubmit = async (event) => {
        // 拡張子が.jpg以外の場合、もしくはファイルが選択されていない場合は処理を中断
        if (!image) {
            alert('ファイルを選択してください');
            return;
        }

        const croppedBlob = await getCroppedCanvas();

        event.preventDefault();
        console.log("call handleProfilePhotoUpdate");
        // imageファイルの拡張子を取得
        const ext = image.name.split('.').pop();
        // ログインユーザー名＋拡張子をファイル名とする
        const filename = activeAccount.localAccountId + '.' + ext;

        const formData = new FormData();
        formData.append('userId', activeAccount.localAccountId);
        formData.append('image', image);

        const response = await execute("GET", protectedResources.getSASToken.endpoint + "?filename=" + filename);
        const sasToken = response.sasToken;
        console.log(sasToken);

        const blobUri = 'https://aliveuploadfiles.blob.core.windows.net/uploads/' + filename + '?' + sasToken;

        const headers = new Headers();
        headers.append('x-ms-blob-type', 'BlockBlob');

        const uploadResponse = await fetch(blobUri, {
            method: 'PUT',
            headers: headers,
            body: croppedBlob // トリミング後の画像をアップロード
        });

        if (!uploadResponse.ok) {
            throw new Error('ファイルアップロードエラー: ' + uploadResponse.statusText);
        }

        console.log('ファイルアップロード成功');
        // 全画面リフレッシュしてモーダルを閉じる
        window.location.reload();
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>プロフィール写真更新</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    {/* 画像を表示 */}
                    {!image && viewImage && <img src={viewImage} alt="プロフィール写真" style={{ width: '100%' }} />}
                    {image && ( // viewImage と image が両方とも存在する場合のみ Cropper をレンダリング
                        <Cropper
                            ref={cropperRef}
                            src={viewImage}
                            style={{ height: 400, width: '100%' }}
                            // その他必要な設定を追加
                            initialAspectRatio={1} // 初期状態の縦横比を1:1に設定
                            aspectRatio={1} // トリミング領域の縦横比を1:1に固定
                            guides={false}
                            crop={cropData}
                            onInitialized={(instance) => {
                                setCropper(instance);
                            }}
                        />
                    )}

                    <Form.Group style={{ marginBottom: '20px' }}>
                        <Form.Label>プロフィール写真を選択</Form.Label>
                        <Form.Control type="file" onChange={handleFileChange} />
                    </Form.Group>
                    <Button variant="primary" type="submit">
                        更新
                    </Button>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    閉じる
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ProfilePhotoUpdateModal;